import { render } from "./DocumentFiletypeIcon.vue?vue&type=template&id=1e9530eb"
import script from "./DocumentFiletypeIcon.vue?vue&type=script&lang=js"
export * from "./DocumentFiletypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__